<template :key="prodct.part">
  <div @click="!isQuantityBtnDisable ? $emit('moreInfo', product) : ''">
    <!-- <v-skeleton-loader
    :loading="false"
    class="mx-auto"
    elevation="2"
    max-width="360"
    type="chip ,list-item ,list-item,list-item"
  > -->
    <div
      class="product"
      :style="{
        mixWidth:
          $vuetify.display.mobile || $vuetify.display.mobile ? '100%' : '550px',
      }"
    >
      <div class="product-img">
        <div class="image-container">
          <v-img
            :width="!isMobile ? '100%' : 150"
            :height="!isMobile ? 230 : 150"
            :aspectRatio="1"
            class="img"
            contain
            crossorigin
            :src="imageResize(product.image)"
          />
          <v-btn
            v-if="authStatus"
            class="favorite-btn"
            icon
            variant="text"
            @click.stop="ActionToggleFavorite"
          >
            <v-icon
              :color="isFavorite ? '#fdc93b' : 'grey'"
              :icon="isFavorite ? 'mdi-star' : 'mdi-star-outline'"
            />
          </v-btn>
        </div>
      </div>
      <div class="product-contact">
        <div class="labels-continer">
          <span
            class="label"
            :class="{ outOfStock: !product.AvailableInStock }"
            >{{
              product.AvailableInStock
                ? $t("Products.productItem.AvailableInStock")
                : $t("Products.productItem.outOfStock")
            }}</span
          >

          <span
            v-if="product?.discountPercent && authStatus"
            class="discount-percent"
          >
            {{ product?.discountPercent }}%
            {{ $t("Products.productItem.discount") }}</span
          >
        </div>
        <div class="more-info" v-if="false">
          <v-icon
            :size="'15px'"
            :color="'#BD9478'"
            :icon="'mdi-information-box'"
          />
          <span>{{ $t("Products.productItem.moreInfo") }}</span>
        </div>

        <div>
          <div class="d-flex flex-column">
            <div
              class="detail d-flex flex-column align-start justify-space-between"
            >
              <div
                :style="{ minWidth: isCarousel ? '280px' : 'unset' }"
                class="product-name"
              >
                {{ product?.name }}
              </div>
            </div>
            <div class="divider"></div>
            <span class="sku">
              {{ product?.sku }}
            </span>
            <div class="d-flex ga-2 flex-start">
              <label v-if="product.package" class="font-weight-bold">{{
                $t("Products.productItem.package")
              }}</label>
              <div v-if="product.package">{{ product.package }}</div>
              <label v-if="product.height" class="font-weight-bold">{{
                $t("Products.productItem.height")
              }}</label>
              <div v-if="product.height">{{ product.height }}</div>
            </div>
          </div>
        </div>
        <div class="prices-wrapper">
          <div class="quantity-wrapper d-flex flex-column">
            <QuantityButtons
              v-if="
                (product.isFromPriceList && authStatus) ||
                !authStatus ||
                priceListId === 'empty'
              "
              :packageQuant="product.package"
              :TheCounter="product.quant"
              @updateCounter="updateProduct"
              :disabled="isQuantityBtnDisable"
            />
            <div class="d-flex flex-column align-end" v-else>
              <span class="">
                <v-icon
                  :size="'15px'"
                  :color="'#FDC70F'"
                  :icon="'mdi-information-box'"
                />
                מוצר לא במגוון
              </span>
              <span
                class="add-toPriceList-btn"
                @click.stop
                v-if="!product.sentPriceListRequest"
              >
                לקבלת הצעת מחיר
                <AddToPriceListModal
                  @submit="handleAddToPriceList"
                  :productName="product?.name"
                  :isLodingSendRquest="isLodingSendRquest"
                  @close-model="closeAddToPriceListModal"
                />
                <!-- </v-btn> -->
              </span>
              <div v-else class="request-sent-message">
                נשלחה בקשה
                <v-icon
                  :size="'15px'"
                  :color="'#36b079'"
                  :icon="'mdi-check-circle'"
                />
              </div>
            </div>
            <div
              v-if="product.quant > 0 || quantity > 0"
              class="package-info d-flex ga-1 w-100 justify-center ma-auto"
            >
              <span>{{ product.package }}</span>
              <span v-if="product.package">במארז</span>
            </div>
          </div>
          <div class="d-flex flex-column">
            <!-- <div class="sku">
              <div>{{ $t("Products.productItem.sku") }}</div>
              <span>
                {{ product?.sku }}
              </span>
            </div> -->
            <Prices
              :sku="product?.sku"
              :discountPrice="product?.discountPrice"
              :originPrice="product?.originPrice"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- </v-skeleton-loader> -->
  </div>
</template>

<script>
import QuantityButtons from "../helpers/QuantityButtons.vue";
import Prices from "./Prices.vue";
import AddToPriceListModal from "../UI/modals/AddToPriceListModal.vue";
import { mapGetters } from "vuex";
// import { getImageUrl } from "../../utilities";

export default {
  emits: ["updateProduct", "moreInfo"],
  components: {
    QuantityButtons,
    Prices,
    AddToPriceListModal,
  },
  data() {
    return {
      quantity: 0,
      isFavorite: false,
      isLodingSendRquest: false,
      isAddPriceListModelOpen: false,
    };
  },
  props: {
    loading: {
      type: Boolean,
      // default: true,
    },
    authStatus: {
      type: Boolean,
      default: false,
    },
    isQuantityBtnDisable: {
      type: Boolean,
    },
    product: {
      type: Object,
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    priceListId: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.isFavorite = this.product.star;
  },
  methods: {
    imageResize(image) {
      const reSizeImage = image.replace("images", "imageResize");
      return reSizeImage + "?width=500";
    },
    OpenModelAddToPriceList() {
      this.isAddPriceListModelOpen = true;
    },
    updateProduct(quantity) {
      this.quantity = quantity;
      this.$emit("updateProduct", { quantity, product: this.product });
    },
    async ActionToggleFavorite() {
      await this.$store.dispatch("Parts/toggleFavorite", this.product.part);
      this.isFavorite = !this.isFavorite;
    },
    async handleAddToPriceList(token) {
      try {
        this.isLodingSendRquest = true;
        await this.$store.dispatch("Parts/sendRquestAddToPriceList", {
          token,
          part: this.product,
        });
        this.$emit("sendRquestAddToPriceList", this.product.part);
      } catch (error) {
        console.error("Add to price list error:", error);
      } finally {
        this.isLodingSendRquest = false;
      }
    },
    closeAddToPriceListModal() {
      this.isAddPriceListModelOpen = false;
    },
  },

  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
    isLongPrice() {
      if (("" + this.product.discountPrice).length > 3) return false;
      else return true;
    },
  },
};
</script>

<style scoped lang="scss">
.package-info {
  font-size: 14px;
  color: #afafaf;
}
.divider {
  width: 100%;
  border-bottom: 1px dashed #dcdcdc;
  margin: 10px 0px;
}
.labels-continer {
  display: flex;
  justify-content: space-between;
  .discount-percent {
    background: #bd94781f;
    color: $primaryColor;
    font-size: 16px;
    font-weight: 400;
    padding: 1px 5px;
  }
}
.product {
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
  cursor: pointer;
}
.product-contact {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-basis: 70%;
}
.product-img {
  // flex-basis: 30%;
  display: flex;
  justify-content: center;
}
.prices-wrapper {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-start;
}
.quantity-wrapper {
  min-width: 140px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
}
.label {
  width: fit-content;
  padding: 0px 10px;
  background: #e6f6ef;
  color: #36b079;
  position: relative;
  padding-right: 20px;
  display: flex;
  height: 24px;
  align-items: center;
  &::before {
    content: "";
    height: 6px;
    width: 6px;
    position: absolute;
    top: 50%;
    background-color: #36b079;
    right: 9px;
    transform: translateY(-50%);
    border-radius: 50%;
  }
}
.outOfStock {
  color: #d13257;
  background: #f2e3e7;
  &::before {
    background-color: #d13257;
  }
}
.detail {
  gap: 5px;
  label {
    font-weight: 700;
  }
  .product-name {
    text-align: start;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    color: black;
  }
  div {
    line-height: 21px;
    color: $orderLineColor;
  }
}

.sku {
  color: $DeepGray;
  font-size: 14px;
  text-align: start;
}
// .sku {
// font-size: 14px;
// display: flex;
// align-items: center;
// gap: 5px;
//   span {
//     color: $DeepGray;
//     font-size: 14px;
//   }
// }
.img {
  object-fit: contain;
  width: 150px;
  height: 150px;
  border-radius: 10px;
}
.more-info {
  text-align: start;
  cursor: pointer;
  margin-top: 10px;
  span {
    text-decoration: underline;
    color: #434343;
  }
}
.add-toPriceList-btn {
  box-shadow: unset;
  // color: $primaryColor;
  color: #434343;
  border-radius: 50px;
  text-decoration: underline;
  &:hover {
    color: $primaryColor;
    cursor: pointer;
  }
}
.isMobile {
  .labels-continer {
    gap: 5px;
    .label {
      font-size: 13px !important;
      width: max-content !important;
    }
    .discount-percent {
      font-size: 13px !important;
      width: max-content !important;
      padding: 0px 10px;
      display: flex;
      align-items: center;
    }
  }
  .detail {
    flex-direction: column;
    align-items: start !important;
    gap: 0 !important;
  }
  .quantity-wrapper {
    justify-content: flex-end;
    align-items: flex-start;
  }
  .prices-wrapper {
    flex-direction: column-reverse !important;
    align-items: flex-start;
  }
  .product {
    padding: 10px !important;
    flex-direction: column;
  }
  .img {
    width: 100% !important;
    height: unset !important;
    aspect-ratio: 1/1 !important;
  }
  .product-name {
    font-size: 16px;
    font-weight: bold;
  }
  .sku {
    font-size: 13px !important;
  }
}
.image-container {
  position: relative;
  width: 100%;

  .favorite-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
      background: white;
    }
  }
}
.request-sent-message {
  color: #36b079;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px;
  border: 1px solid #36b079;
  border-radius: 50px;
  text-align: center;
  justify-content: center;
}
</style>
